<big-ui-modal-frame
    *transloco="let t; prefix: 'uiModalBigtionaer'"
    [closeBtnTitle]="t('closeOverlayBtn')"
    (closeModal)="popoverRef.close({ leaveForm: false })">
    <ng-container title>{{ title }}</ng-container>
    <ng-container content>
        <div class="flex flex-col gap-8">
            @if (description) {
                <p class="mb-0">
                    <span [innerHTML]="description | sanitize: securityContext"></span>
                </p>
            }

            @if (text1 && showMore1Callback) {
                <span>
                    <p
                        class="mb-0"
                        [innerHTML]="text1 | sanitize: securityContext"></p>
                    <big-ui-button
                        [buttonStyle]="'tertiary'"
                        (click)="showMore1Callback(popoverRef)"
                        class="text-primary dark:text-white underline py-3 block"
                        [classList]="['flex items-center gap-2']">
                        {{ t('showMore') }}
                        <big-icon
                            [icon]="iconArrowRight"
                            [size]="'w-4'"
                            class="fill-current" />
                    </big-ui-button>
                </span>
            }

            @if (text2 && showMore2Callback) {
                <span>
                    <p
                        class="mb-0"
                        [innerHTML]="text2 | sanitize: securityContext"></p>
                    <big-ui-button
                        [buttonStyle]="'tertiary'"
                        (click)="showMore2Callback(popoverRef)"
                        class="text-primary dark:text-white underline py-3 block"
                        [classList]="['flex items-center gap-2']">
                        {{ t('showMore') }}
                        <big-icon
                            [icon]="iconArrowRight"
                            [size]="'w-4'"
                            class="fill-current" />
                    </big-ui-button>
                </span>
            }
        </div>
    </ng-container>
</big-ui-modal-frame>
